// JavaScript Document





function getJobInfoList(){
  setTimeout(function(){
      jobLevelList = [];
      jobLocationList = [];
      jobModelList = [];
      $('.jobSelectParam').each(function(){
         tempInfoArray = $(this).data('jobselect');
      });
  }, 500);
}

/*
function toggleBox(_elem,_class){
    if($(_elem).text()=='Auswahl filtern'){
        //$('.jobCheck').prop('checked',false);
        $(_elem).text('Alle anzeigen');
    }else{
        $(_elem).text('Auswahl filtern');
        $('.jobLink').addClass('active');
    }
    $('.'+_class).toggleClass('active');
}
*/




function manageJobDisplay(_elem){
    cat= $(_elem).data('categorie');
    val= $(_elem).data('value');
    if($(_elem).prop('checked')==true){
        $('.jobLink').each(function(){
           if($(this).data('jobsingle')[0][cat]==val){
               $(this).addClass('active');
           } /*else{
               $(this).removeClass('active');
           }*/
        });
    }else{
        $('.jobLink').each(function(){
            if($(this).data('jobsingle')[0][cat]==val){
                $(this).removeClass('active');
            }/* else{
                $(this).addClass('active');
            }*/
        });

    }
}


